import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class GoodFaithEstimateProduct extends Fragment {
  @attr() productDetails;
  @attr() practiceProductId;
  @attr('number') quantity;
  @attr('number') price;
  @attr('number') position;

  get total() {
    const { quantity = 0, price = 0 } = this;

    return quantity * price;
  }
}
